"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var KEYS;
(function (KEYS) {
    KEYS[KEYS["Z"] = 90] = "Z";
    KEYS[KEYS["X"] = 88] = "X";
    KEYS[KEYS["C"] = 67] = "C";
    KEYS[KEYS["V"] = 86] = "V";
    KEYS[KEYS["S"] = 83] = "S";
    KEYS[KEYS["P"] = 80] = "P";
    KEYS[KEYS["ENTER"] = 13] = "ENTER";
    KEYS["CTRL"] = "CTRL";
    KEYS[KEYS["SHIFT"] = 16] = "SHIFT";
    KEYS[KEYS["DELETE"] = 46] = "DELETE";
    KEYS[KEYS["BACKSPACE"] = 8] = "BACKSPACE";
    KEYS[KEYS["ESC"] = 27] = "ESC";
})(KEYS || (KEYS = {}));
var KeyLogService = /** @class */ (function () {
    function KeyLogService() {
        var _this = this;
        this.Z = KEYS.Z;
        this.X = KEYS.X;
        this.C = KEYS.C;
        this.V = KEYS.V;
        this.S = KEYS.S;
        this.P = KEYS.P;
        this.ENTER = KEYS.ENTER;
        this.CTRL = KEYS.CTRL;
        this.SHIFT = KEYS.SHIFT;
        this.DELETE = KEYS.DELETE;
        this.BACKSPACE = KEYS.BACKSPACE;
        this.ESC = KEYS.ESC;
        this.BODY_SELECTOR = 'body';
        // browsers all do it differently
        this.CTRL_KEYS = [17, 91, 93, 224];
        this.keyStack = [];
        this.actions = {};
        var bodyEl = $(this.BODY_SELECTOR);
        bodyEl.on('keydown', function (evt) { return _this.logKeypress(evt); });
        bodyEl.on('keyup', function (evt) { return _this.removeKeypress(evt); });
    }
    /*
     * Register a callback with a key combination
     * Key combinations are either arrays or strings that concatenate joined keycodes with a "+"
     */
    // @ts-ignore
    // @ts-ignore
    KeyLogService.prototype.registerAction = function (keys, callback) {
        keys = this.formatKeys(keys);
        if (!this.actions[keys]) {
            this.actions[keys] = [];
        }
        // make sure we don't add it twice
        if (this.actions[keys].indexOf(callback) < 0) {
            this.actions[keys].push(callback);
        }
        // return something for testing
        return this.actions;
    };
    // @ts-ignore
    // @ts-ignore
    KeyLogService.prototype.deregisterAction = function (keys, callback) {
        keys = this.formatKeys(keys);
        var index = (this.actions[keys] || []).indexOf(callback);
        if (index >= 0) {
            this.actions[keys].splice(index, 1);
            if (!this.actions[keys].length) {
                delete this.actions[keys];
            }
        }
        // return something for testing
        return this.actions;
    };
    KeyLogService.prototype.logKeypress = function (evt) {
        // note: isTextArea is our own jQuery Extension. We are also using it in item-mover.js and item-selector.js
        if ($(evt.target).isTextArea()) {
            return;
        }
        var pressedKey = this.getKey(evt);
        // it's not already in there
        // @ts-ignore
        if (this.keyStack.indexOf(pressedKey) < 0) {
            // @ts-ignore
            this.keyStack.push(pressedKey);
            this.keyStack.sort();
        }
        // if an action was executed, then prevent the browser default,
        // we want to do this with almost all of the keybindings such as print, copy, etc
        var executed = this.executeActions(evt);
        if (executed) {
            evt.stopImmediatePropagation();
            // returning false doesn't let us deregsiter on keyup since it won't be called
            this.removeKeypress(evt);
            return false;
        }
    };
    /*
     * returns true if there was an action that was executed
     */
    KeyLogService.prototype.executeActions = function (evt) {
        var keys = this.keyStack.join('+');
        if (this.actions[keys]) {
            lodash_1.default.each(this.actions[keys], function (callback) {
                callback(evt);
            });
            return true;
        }
        return false;
    };
    KeyLogService.prototype.removeKeypress = function (evt) {
        var pressedKey = this.getKey(evt);
        // if the key we are lifting isn't in the stack, it must have been our meta key
        // @ts-ignore
        if (this.keyStack.indexOf(pressedKey) < 0) {
            pressedKey = this.CTRL;
        }
        // @ts-ignore
        var index = this.keyStack.indexOf(pressedKey);
        if (index >= 0) {
            this.keyStack.splice(index, 1);
        }
    };
    KeyLogService.prototype.getKey = function (evt) {
        var pressedKey;
        pressedKey = evt.which;
        if (this.isCtrlPressed(pressedKey)) {
            pressedKey = this.CTRL;
        }
        return pressedKey;
    };
    /*
     * Browsers all do this differently, so we want to capture ANY CMD / CTRL regardless of browser or OS
     * Chrome / Safari: 91 (left), 93 (right)
     * Opera / IE: 17 (The control key, which is the same, so if they are on OSX, they can hit CMD or CTRL)
     * FF: 93
     */
    KeyLogService.prototype.isCtrlPressed = function (key) {
        return (this.CTRL_KEYS.indexOf(key) >= 0);
    };
    KeyLogService.prototype.formatKeys = function (keys) {
        if (!lodash_1.default.isArray(keys)) {
            keys = (keys + '').split('+');
        }
        return keys.sort().join('+');
    };
    return KeyLogService;
}());
exports.default = KeyLogService;
(function (angularModule) {
    angularModule.service('prKeylogService', KeyLogService);
})(angular.module('qualtrics.pr'));
